// prod urls
export const baseURL = 'https://moilapp.com';
export const baseURL1 = 'https://candidate.moilapp.com';
export const employerUrl = "https://business.moilapp.com";
export const interviewURL = "https://ai.moilapp.com/plan";


// // localhost urls
// export const baseURL = 'http://localhost:8000';
// export const baseURL1 = 'http://localhost:3000';
// export const employerUrl = "http://localhost:3001";
// export const interviewURL = 'http://localhost:8003/plan';
